import { MenuItem } from '../../side-bar/menu-item';

export class DropdownMenuItem extends MenuItem {
  public override items?: DropdownMenuItem[];
}
